import { capitalize, upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';

import useStore from '../../../../../store';
import { Stage, TenantBooking } from '../../../../../types/bookings';
import {
  StyledButton,
  StyledButtonWrapper,
} from '../BookingInformationButton.styles';

interface IBookingInformationProps {
  booking: TenantBooking;
  onCounterOfferOpen: () => void;
}

const BookingTenantInformationButton = ({
  booking,
  onCounterOfferOpen,
}: IBookingInformationProps) => {
  const { t } = useTranslation(['booking', 'common']);
  const completeRequestBookingURL = `${process.env.REACT_APP_SITE_URL}/bookings/${booking.id}/0`;
  const updateRequestBookingURL = `${process.env.REACT_APP_SITE_URL}/bookings/${booking.id}`;
  const { user } = useStore(state => ({
    user: state.user,
  }));

  if (booking.stage === Stage.Draft) {
    return (
      <StyledButtonWrapper flexProperty="flex-end">
        <StyledButton
          user={user?.type}
          onClick={() => window.open(completeRequestBookingURL)}
        >
          {capitalize(t('common:complete'))}
        </StyledButton>
      </StyledButtonWrapper>
    );
  }

  if (booking.stage === Stage.Pending && booking.pricing.counter_offer === 0) {
    return (
      <StyledButtonWrapper flexProperty="flex-end">
        <StyledButton
          user={user?.type}
          onClick={() => window.open(updateRequestBookingURL)}
        >
          {upperFirst(t('booking:updateInformation'))}
        </StyledButton>
      </StyledButtonWrapper>
    );
  }

  if (booking.pricing.counter_offer > 0 && booking.stage === Stage.Pending) {
    return (
      <StyledButtonWrapper flexProperty="flex-end">
        <StyledButton user={user?.type} onClick={onCounterOfferOpen}>
          {upperFirst(t('booking:reviewCounterOffer'))}
        </StyledButton>
      </StyledButtonWrapper>
    );
  }

  return null;
};

export default BookingTenantInformationButton;
